module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#40404C;} </style><rect x=\"6\" y=\"5\" class=\"st0\" width=\"5\" height=\"2\"></rect><rect x=\"6\" y=\"8\" class=\"st0\" width=\"5\" height=\"2\"></rect><rect x=\"6\" y=\"11\" class=\"st0\" width=\"5\" height=\"2\"></rect><path class=\"st0\" d=\"M15,4V1H2v16h3v3h13V4H15z M4,15V3h9v12H4z M16,18H7v-1h8V6h1V18z\"></path></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/svg-inline-loader?removeSVGTagAttrs=false!./src/img/resources.svg
 ** module id = 1058
 ** module chunks = 0
 **/